import { render, staticRenderFns } from "./FiscalDocumentEvent.vue?vue&type=template&id=5a406d00&scoped=true&"
import script from "./FiscalDocumentEvent.vue?vue&type=script&lang=js&"
export * from "./FiscalDocumentEvent.vue?vue&type=script&lang=js&"
import style0 from "./FiscalDocumentEvent.vue?vue&type=style&index=0&id=5a406d00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a406d00",
  null
  
)

export default component.exports